<template>
  <ui-dialog :show="isOpen" closable @input="close" max-width="623">
    <template #header>
      <h3 class="heading">
        {{ $t("message.facilityDetails.reviewFormLink") }}
      </h3>
    </template>
    <template #default>
      <div class="containter">
        <v-text-field
          class="review-link"
          :value="reviewFormLink"
          outlined
          readonly
          append-icon="mdi-content-copy"
          @click:append="copyToClipboard"
        >
        </v-text-field>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "ReviewFormLinkDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    reviewFormLink: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async copyToClipboard() {
      await navigator.clipboard.writeText(this.reviewFormLink);
      this.$notify({
        group: "default",
        type: "success",
        text: this.$t("message.common.copiedToClipboard")
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.containter {
  margin-top: $spacing;
  min-height: 100px;
}

.review-link {
  width: 100%;
  border-radius: 50px;

  ::v-deep .v-input__slot {
    padding: 0px 25px !important;
  }
}
</style>
